var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.588,
    height: 26.588,
    viewBox: "0 0 24.588 24.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.324,9.259H21.8a9.929,9.929,0,0,0-.64-1.541l.37-.37a2.263,2.263,0,0,0,0-3.2L20.442,3.056a2.263,2.263,0,0,0-3.2,0l-.37.37a9.936,9.936,0,0,0-1.541-.64V2.263A2.266,2.266,0,0,0,13.066,0H11.522A2.266,2.266,0,0,0,9.259,2.263v.522a9.926,9.926,0,0,0-1.541.64l-.37-.37a2.263,2.263,0,0,0-3.2,0L3.056,4.146a2.264,2.264,0,0,0,0,3.2l.37.37a9.927,9.927,0,0,0-.64,1.541H2.264A2.266,2.266,0,0,0,0,11.522v1.543a2.266,2.266,0,0,0,2.264,2.263h.522a9.929,9.929,0,0,0,.64,1.541l-.37.37a2.263,2.263,0,0,0,0,3.2l1.091,1.091a2.263,2.263,0,0,0,3.2,0l.37-.37a9.936,9.936,0,0,0,1.541.64v.522a2.266,2.266,0,0,0,2.264,2.263h1.543a2.266,2.266,0,0,0,2.264-2.263V21.8a9.926,9.926,0,0,0,1.541-.64l.37.37a2.263,2.263,0,0,0,3.2,0l1.091-1.091a2.264,2.264,0,0,0,0-3.2l-.37-.37a9.927,9.927,0,0,0,.64-1.541h.522a2.266,2.266,0,0,0,2.264-2.263V11.522a2.266,2.266,0,0,0-2.264-2.263Zm-10.03,8.385a5.35,5.35,0,1,1,5.35-5.35A5.356,5.356,0,0,1,12.294,17.644Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifSettings);
export default __webpack_public_path__ + "static/media/notif-settings.9c7fe03684acae27d43fd83386e8962d.svg";
export { ForwardRef as ReactComponent };